import React from 'react'
import { Link } from 'react-router-dom'

import { OrderResult } from '../components'
import { ProductBox, TagSorter } from './containers'
import { TypeInfo } from './components'

import config from 'config'
import { handleProducts, handleTags } from './func'
import 'assets/sass/ECommerce/products.scss'


export default class ProductList extends React.PureComponent {
	componentDidUpdate(prevProps, prevState) {
		const { result, onProductListLoadRequest } = this.props;

		if (prevProps.result !== result && result === 1) {
			onProductListLoadRequest();
		}
	}

	render() {
		const { products, category, result, history, onModalOpen } = this.props;
		const productTypes = config.product.PRODUCT_TYPE;
		const propductList = handleProducts(products, category);
		const tagList = handleTags(propductList);
		const arrProductType = Object.keys(productTypes);

		return (
			<div className='product-list'>
				<div className='fixed-bar'>
					<div className='toolbar'>
						<TypeInfo type={category} />

						<div className='product-btn pull-right'>
							{arrProductType.map((key) => (
								<Link
									className={`${key} ua-btn ${(category === key) ? 'default' : 'outline'} contrast`}
									to={`/e-com/product-view/${key}`}
									key={key}
								>
									{productTypes[key].title}
								</Link>
							))}
						</div>
					</div>

					<TagSorter tags={tagList} />
				</div>
				
				<div className={`product-all ${category} margin-bottom-10`}>
					{propductList.map((product, key) => ((product.category === '1' || product.category === '3' 
							|| product.category === '4' || product.category === '8')
						? (
							<ProductBox 
								product={product} 
								history={history} 
								onModalOpen={onModalOpen} 
								key={key} 
							/>
						)
						: null
						))}
				</div>

				<OrderResult result={result} />
			</div>
		);
	}
}
